import { gql } from "@apollo/client";
import { Invoice as invoice } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_INVOICE = props => gql`
  query FetchInvoice($id: Int) {
    invoice(id: $id) {
      ${invoice(props)}
    }
  }
`;

const FETCH_INVOICES = props => gql`
  query FetchInvoices($input: InvoicesFilterInput!) {
    invoices(input: $input) {
      count
      edges {
        ${invoice(props)}
      }
    }
  }
`;

const FETCH_INVOICES_V2 = props => gql`
  query FetchInvoicesV2($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      count
      edges {
        ${invoice(props)}
      }
      sqlQuery
    }
  }
`;

const INVOICE_LIST_FIELDS = `
  count
  edges {
    id
    date
    company {
      name
      code
      invoiceCode
    }
    type {
      id
      description
    }
    approved
    contact {
      name
      img
    }
    companyName
    number
    proforma
    reference
    currency {
      code
    }
    invoiceTotals
    dueDate
  }
  sqlQuery
`;

const FETCH_INVOICES_LIST = props => gql`
  query FetchInvoicesList($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      ${INVOICE_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_INVOICES_SEARCH_RESULTS = gql`
  query FetchInvoicesSearchResults($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      ${INVOICE_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

// Minimal lookup used to resolve a human reference (e.g. "WCA19105") to the
// numeric invoice id so URLs like /invoice/WCA19105 can redirect. The prefix
// ("WCA") scopes the search to a company and the digits ("19105") match the
// invoice number.
const FETCH_INVOICE_ID_BY_REFERENCE = gql`
  query FetchInvoiceIdByReference($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      count
      edges {
        id
        number
      }
    }
  }
`;

const FETCH_INVOICE_INSTANCE = gql`
  query FetchInvoiceInstance($input: InvoiceInstanceInput!) {
    invoiceInstance(input: $input) {
      amount
      amountAboveSalePrice
      consigneeSplit
      consigneeSplitRate
      customs
      description
      discount
      invoiceId
      nominalId
      offerId
      ref
      salePrice
      source
      tax
      taxAmount
      matchedSalesPeople {
        invoiceHasSalesPeople
        offer {
          id
        }
        consignment {
          id
        }
        salesPeople {
          salesUserId
          salesUser {
            id
            name
          }
          typeId
          split
        }
      }
      success
      error
    }
  }
`;

export {
  FETCH_INVOICE,
  FETCH_INVOICES,
  FETCH_INVOICES_V2,
  FETCH_INVOICE_INSTANCE,
  FETCH_INVOICES_LIST,
  FETCH_INVOICES_SEARCH_RESULTS,
  FETCH_INVOICE_ID_BY_REFERENCE,
};
